import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { ResetPasswordModal } from "web-apps/company/components/login/resetPasswordModal.component";
import { CustomLink, H3 } from "components/Typography/text.styled";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { LoginForm } from "../components/login/loginForm.component";

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [email, setEmail] = useState("");

  return (
    <LoggedOutPageContainer>
      <H3>{t("LoginCompany.EmployeeLogin")}</H3>
      <LoginForm email={email} setEmail={setEmail} />
      <CustomLink
        onClick={() => setPasswordModalOpen(true)}
        color={Color.Destructive}
      >
        {t("LoginCompany.ForgotPassword")}
      </CustomLink>
      <ResetPasswordModal
        passwordModalOpen={passwordModalOpen}
        setPasswordModalOpen={setPasswordModalOpen}
        email={email}
        setEmail={setEmail}
      />
    </LoggedOutPageContainer>
  );
};
